export const SET_UNITY = "UNITIES/SET_UNITY";
export const SET_UNITIES = "UNITIES/SET_UNITIES";
export const SET_PAGINATION = "UNITIES/SET_PAGINATION";
